export const WINDOW_KEY = '__tpClientQueue';

type Track = ['event' | 'page', Event, boolean];

// `any` here is really the TP client, but the way the project is currently
// setup makes it hard to type it correctly here because the compiler drags
// the whole client into the compilation of the types
export type ClientCallback = (client: any) => void;
// export type ClientCallback = (client: typeof import('./index')) => void;

type GetClient = ['get-api', ClientCallback];

export type TransportFormat = Track | GetClient;

type HookHandler = (s: string, p: string) => void;

declare global {
    interface Window {
        __tpClientHook: HookHandler[];
        __tpClientQueue: any;
        tpDataLayer: [];
    }
}

export interface Event {
    type?: string;
    name?: string;
    url?: string;
    referrer?: string;
    viewUuid?: string;
    applicationName?: string;
    properties?: Properties;
    labels?: string[];
}

export interface Properties {
    [s: string]: any;
}
